// Ключ `GET /api/stats/summary` (ключи `$api` — `[method, path, init]`). Сводку перечитывают
// по событию `stats.updated`, когда быстрый разбор новых матчей закончился.
export const STATS_SUMMARY_QUERY_KEY = ["get", "/api/stats/summary"] as const;
